import React from 'react'
import { compose, lifecycle } from 'recompose'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import IconSVG from 'svg-inline-react'
import { Skill } from '@driftt/tide-core-legacy'
import { fetchAssistantAgentSettings } from 'app/modules/assistantSettings/actions'

import IntegrationConnector from 'components/Integration/components/IntegrationConnector'
import { fetchIntegrationStates } from 'app/modules/integrations/actions'
import { SALESFORCE_AUTH_URL, SALESFORCE_PAYLOAD } from 'constants/ResourcesConstants'

import styles from './style.styl'

const MeetingPrepSVG = require('!svg-inline?removeSVGTagAttrs=false!images/assistant-config/meeting-prep-skill.svg')
const MeetingCancelSVG = require('!svg-inline?removeSVGTagAttrs=false!images/assistant-config/meeting-cancel-skill.svg')
const FollowUpSVG = require('!svg-inline?removeSVGTagAttrs=false!images/assistant-config/follow-up-skill.svg')

const salesforceConnectButton = (
  <IntegrationConnector
    onIntegrationConnected={this.onIntegrationConnected}
    integrationId="salesforce"
    isOauth={true}
    oauthLink={SALESFORCE_AUTH_URL}
    title="Connect Salesforce"
    connectorType="button"
    buttonType="primary"
    className="salesforce-integration-connector"
    oauthQueryParams={SALESFORCE_PAYLOAD}
  />
)

class AssistantOrgSalesforceConnect extends React.Component {
  onIntegrationConnected = () => {
    this.props.actions.fetchIntegrationStates()
  }

  render() {
    const SkillsComponents = [
      {
        skillName: 'Always be prepared for your meeting',
        subHead: `Before a demo, you’ll get an email with enriched data like the attendee’s job title, company, and links to their LinkedIn and Salesforce record.`,
        canOpen: false,
        settingName: 'MEETING_PREP',
        headerIcon: () => <IconSVG src={MeetingPrepSVG} />,
      },
      {
        skillName: 'Keep your leads warm',
        subHead:
          'If you haven’t followed up after a meeting has been canceled or rescheduled, we’ll send you a reminder so you don’t forget.',
        canOpen: false,
        settingName: 'MEETING_CANCELLED',
        headerIcon: () => <IconSVG src={MeetingCancelSVG} />,
      },
      {
        skillName: 'Never lose an Opportunity',
        subHead:
          'If you haven’t followed up after a meeting has been held, we’ll send you a reminder so you don’t forget.',
        canOpen: false,
        settingName: 'DEMO_FOLLOW_UP',
        headerIcon: () => <IconSVG src={FollowUpSVG} />,
      },
    ]

    return (
      <div className={styles.AssistantOrgSalesforceConnect}>
        <div className="assistant-config-header">
          <div className="left-content">
            <div className="title">
              <IconSVG
                className="connected-icon"
                src={require('!svg-inline?removeTags=true!images/svg/robot-icon.svg')}
              />
              The Drift Assistant
            </div>
            <div className="description">
              Make sure your team never lets a lead or opportunity fall through the cracks again. Help them
              succeed by configuring your team&rsquo;s Drift Assistant with your Salesforce account.
            </div>
          </div>
          <div className="right-content">
            {salesforceConnectButton}
            <a href="https://help.drift.com/article/drift-assistant-basics/?v=1536180632162" target="_blank">
              Learn More
            </a>
          </div>
        </div>
        <div>
          {SkillsComponents.map((skillProps, i) => {
            const props = { ...skillProps }
            return <Skill {...props} key={`skill-${i}`} />
          })}
        </div>
        <div className="assistant-page-footer">
          <p>
            Connect your Salesforce account to map the Drift Assistant to match how your team identifies
            qualified leads and demos held.
          </p>
          {salesforceConnectButton}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchAssistantAgentSettings,
      fetchIntegrationStates,
    },
    dispatch
  ),
})

export default compose(
  connect(
    undefined,
    mapDispatchToProps
  ),
  lifecycle({
    componentDidMount() {
      const { actions } = this.props
      actions.fetchAssistantAgentSettings()
    },
  })
)(AssistantOrgSalesforceConnect)



// WEBPACK FOOTER //
// ./src/scripts/components/settings/AssistantConfigOrg/AssistantOrgSalesforceConnect/index.js